<template>
  <div class="home-big">
    <div class="header-logo">
      <div class="header-logo-img">
          <img @click="toZDYT" src="./logo555.png" alt="">
      </div>
      <!-- <div class="header-logo-title">
          <p>{{'学生体质健康管理系统'}}</p>
          <p></p>
          <p>{{'Student Physical Health Intelligent Management System'}}</p>
      </div> -->
      <div class="header-logo-p">
        <p></p>
        <p></p>
        <p>{{'客服热线 :'}}
          <span>{{'400-001-9078'}}</span>
        </p>
      </div>
    </div>
    <div class="home">
      <el-container style="height: 100%;">
        <el-header>
            <s-header></s-header>
          </el-header>
        <el-container class="show-el-container">
          <left-menu></left-menu>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
    <h2 class="footer-show"> 
      <p>www.studentfit.cn&nbsp&nbsp版权所有<span @click="toAnquan">&nbsp京ICP备20011658号-2</span></p>
    </h2>
  </div>
</template>

<script>
  import LeftMenu from 'components/menu/menu'
  import SHeader from 'components/header/header'
  export default {
    data () {
      return {}
    },
    components: {
      LeftMenu,
      SHeader
    },
    methods:{
      toAnquan(){
        window.open('https://beian.miit.gov.cn')
      },
      toZDYT(){
        window.open('http://www.lexiangzhidong.com/')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.footer-show{
    height: 70px;
    width: 100%;
    z-index: 99999999;
    display: flex;
    position: fixed;
    color: #000;
    bottom: 0;
    left: 0;
    flex-flow: column;
    // align-items: center;
    font-size: 13px;
    vertical-align: baseline;
    font-family: Avenir,Helvetica,Arial,sans-serif;
    // user-select:none;
    font-family: initial;
    // font-weight: 600;
    // justify-content: center;
  }
  .footer-show>p{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    // align-items: flex-end;
  }
  .footer-show>p>span{
    cursor:pointer;
  }
  .footer-show>p>span:hover{
    color: #ff9966;
  }
  .footer-show{
    height: 6%;
    user-select:none;
    display: flex;
    align-items: center;
    font-size: 13px;
    // font-weight: 600;
    font-family: initial;
    // font-weight: 600;
    justify-content: center;
  }
  .header-logo{
    user-select:none;
    height:8%;
    width: 97%;
    padding: 0px 20px 0 20px;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .header-logo-img{
    width: 200px;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
  }
  .header-logo-img>img{
    // width: 68%;
    // height: 96%;
    width: 100%;
    // margin-bottom: -4%;
    // position: absolute;
    // bottom: 0;
    // left: 0;
  }
  .header-logo-title{
    float: left;
    width: auto;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-flow: column;
  }
  .header-logo-title>p{
    flex: 1;
    width: auto;
    display: flex;
    align-items:flex-end;
    font-size: 17px;
    font-family: emoji;
    font-weight: 600;
    overflow: hidden;
  }
  .header-logo-title>p:nth-of-type(1){
    font-family:'Avenir', Helvetica, Arial, sans-serif;
    display: flex;
    font-size: 17px;
    align-items:flex-end;
  }
  .header-logo-title>p:nth-of-type(2){
    flex: 0.3;
  }
  .header-logo-title>p:nth-of-type(3){
    font-weight: 600;
    font-size: 14px;
    align-items: flex-start;
  }
  .header-logo-p{
    float: right;
    width: auto;
    height: 100%;
    display: flex;
    flex-flow: column;
  }
  .header-logo-p>p:nth-of-type(2){
    flex: 0.3;
  }
  .header-logo-p>p{
    flex: 1;
    display: flex;
    height: 100%;
    align-items: flex-end;
    font-size: 15px;
    // font-weight: 600;
    align-items: flex-start;
  }
  .header-logo-p>p>span{
    // font-weight: 600;
    font-size: 15px;
  }
  .show-el-container{
    height: -webkit-calc(100% - (50px));
    background-color:#f4f4f4;
    // border-radius: 0px 0px 10px 10px;
  }
  .home-big{
    height: 100%;

  }
  .home{
    // height:100%;
    height:86%;
    // margin-top: 20px;
    margin: 0 auto;
    width: 97%;
    border-radius: 10px 10px 0 0;
    transition: all .6s;
    box-shadow: 0 0 4px 0px #ccc;
  }
  .home:hover{
    box-shadow: 0 0 10px 0px #ccc;
  }
  .el-header {
    // background-color: #fff;
    // color: #333;
    // line-height: 60px;
    // position:fixed;
    // top:0;
    // right:0;
    padding: 0 20px 0 0px !important; 
    // left:220px;
    color: #fff;
    height: 50px !important;
    // background-image: url('../header/images/backgroundImage_03.jpg');
    // background-repeat: repeat-x;
    // background-size: auto 100%;
    background: #fa7938;
    border-bottom: 3px solid #ff9966;
    box-sizing: border-box;
    line-height: 50px;
    border-radius: 10px 10px 0 0;
    z-index:999;
    // border-bottom:1px solid #dce6e1;
  }

  .el-aside {
    color: #333;
    height:100%;
  }
  .main-wrapper {
    border: 1px solid #dce6e1;
    background-color: #ffffff;
    margin-top: 0px !important;
    padding: 15px 15px;
    height: calc(100% - (86px)) !important;
  }
  .pagination-wapper{
    padding: 0 !important;
  }
  .el-main {
    // height: -webkit-calc(100% - (60px));
    // height: -moz-calc(100% - (60px));
    // height: calc(100% - (60px));
    width:100%;
    padding: 0px !important;
    // padding:15px;
    // padding-top:75px;
    // padding-bottom:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue